import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import OpenBusinessAccountPage from './OpenBusinessAccountPage';
import { dataCaptureSelectors, saveOpenBusinessAccountForm } from '../../store/dataCapture';
import { OPEN_BUSINESS_ACCOUNT_PAGE } from '../../utils/constants';
class OpenBusinessAccountSection extends Component {
  constructor(props) {
    super(props);
    this.onConfirmationCheckboxChange = this.onConfirmationCheckboxChange.bind(this);
    this.state = { isTermsChecked: false };
  }
  onConfirmationCheckboxChange(value) {
    this.setState({ isTermsChecked: value });
  }
  render() {
    const { bankId, brandId, saveOpenBusinessAccountForm, getBusinessData } = this.props;

    return (
      <OpenBusinessAccountPage
        brandId={brandId}
        bankId={bankId}
        saveOpenBusinessAccountForm={saveOpenBusinessAccountForm}
        getBusinessData={getBusinessData}
        onConfirmationCheckboxChange={this.onConfirmationCheckboxChange}
        isTermsChecked={this.state.isTermsChecked}
      />
    );
  }
}

OpenBusinessAccountSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveOpenBusinessAccountForm: PropTypes.func.isRequired
};

const actionCreators = {
  saveOpenBusinessAccountForm
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  getBusinessData: dataCaptureSelectors.getBusinessData(state, OPEN_BUSINESS_ACCOUNT_PAGE)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OpenBusinessAccountSection);
